const Footer = () => {
    return (
        <div className="footer">
            Made with
            <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
                &nbsp;React
            </a>
            at&nbsp;
            <a
                href="https://www.lereacteur.io/"
                target="_blank"
                rel="noreferrer"
            >
                Le Reacteur
            </a>
            by
            <a
                href="https://github.com/csengmany"
                target="_blank"
                rel="noreferrer"
            >
                &nbsp;Cathy Sengmany
            </a>
        </div>
    );
};

export default Footer;
